import { AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, PLATFORM_ID, Renderer2 } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-fs-toast',
  standalone: true,
  imports: [CommonModule, ToastModule],
  template: `
    <p-toast [key]="key" position="top-right" styleClass="fs-toast" [baseZIndex]="999999">
      <ng-template pTemplate="message" let-msg>
        <div class="fs-toast-body">
          <span class="fs-toast-icon"
            [style.color]="msg.severity === 'success' ? '#1E8E5A'
                         : msg.severity === 'warn'    ? '#B7791F'
                         : msg.severity === 'info'    ? '#0369A1'
                         : '#D93025'">
            {{ msg.severity === 'success' ? '✓' : msg.severity === 'info' ? 'ℹ' : '⚠' }}
          </span>
          <div class="fs-toast-text">
            <div class="fs-toast-title">{{ msg.summary }}</div>
            <div class="fs-toast-detail-text">{{ msg.detail }}</div>
          </div>
        </div>
        <div class="fs-timerbar"
          [class.fs-timerbar--ok]="msg.severity === 'success'"
          [class.fs-timerbar--info]="msg.severity === 'info'"
          [class.fs-timerbar--warn]="msg.severity === 'warn'"
          [class.fs-timerbar--err]="msg.severity === 'error'"></div>
      </ng-template>
    </p-toast>
  `,
})
export class FsToastComponent implements AfterViewInit, OnDestroy {
  @Input() key: string | undefined = undefined;

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
  ) {}

  // PrimeNG's .p-dialog sets a permanent `transform`, which makes it a containing
  // block for position:fixed descendants (CSS spec). That traps this toast inside
  // whichever dialog it's declared in instead of positioning it to the viewport,
  // and PrimeNG 21's <p-toast> no longer has an `appendTo` input to work around it.
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.appendChild(document.body, this.el.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.el.nativeElement.remove();
    }
  }
}
